<template>
  <div id="mapTo">
    <a-row>
      <a-table
        :rowSelection="{
          selectedRowKeys: partselectedRowKeys,
          onChange: onSelectChange
        }"
        :columns="mapTocolumns"
        :dataSource="partTablist"
        size="small"
        :pagination="nopagination"
        :customRow="customRowEvent"
        :rowClassName="rowClassName"
        :locale="tabelText"
        :loading="parTableLoading"
      >
        <template
          v-for="(item, index) in scopedSlotsArray"
          :slot="item"
          slot-scope="text"
        >
          <span :key="index">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span class="tableFontSize">{{ text }}</span>
              </template>
              <div class="tableFontSize">{{ text }}</div>
            </a-tooltip>
          </span>
        </template>
      </a-table>
      <a-row type="flex" justify="space-between" style="padding: 8px">
        <a-col>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.Add') }}</span>
            </template>
            <img @click="addMapTo('add')" class="sbxs" src="../../assets/img/ss-add.png"  width="22" height="22">
          </a-tooltip>
          <a-popconfirm
            :title="$t('generic.AreyoudeleTask')"
            :okText="$t('generic.Yes')"
            :cancelText="$t('generic.No')"
            @confirm="deleteMaptoPar"
          >
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t('generic.Delete') }}</span>
              </template>
              <img class="sbxs mllr4" src="../../assets/img/ss-delete.png"  width="22" height="22">
            </a-tooltip>
          </a-popconfirm>
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.Edit') }}</span>
            </template>
            <img  @click="addMapTo('edit')" class="sbxs" src="../../assets/img/ss-edit.png"  width="22" height="22">
          </a-tooltip>
        </a-col>
        <a-col>
          <a-pagination
            size="small"
            :total="partTabPage.totalElements"
            :defaultCurrent="partTabPage.mapToPageCurrent"
            :pageSize="partTabPage.pageSize"
            :showTotal="total => `Total ${partTabPage.totalElements} Records`"
            @change="partTabChange"
            showQuickJumper
          />
        </a-col>
      </a-row>
    </a-row>

    <a-tabs>
      <a-tab-pane tab="sub Page" key="1">
        <a-col style="margin:10px 0 0 10px">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.Add') }}</span>
            </template>
            <img @click="addSubMapTo" class="sbxs" src="../../assets/img/ss-add.png"  width="22" height="22">
          </a-tooltip>
          <a-popconfirm
            :title="$t('generic.AreyoudeleTask')"
            :okText="$t('generic.Yes')"
            :cancelText="$t('generic.No')"
            @confirm="deleteMaptoSub"
          >
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ $t('generic.Delete') }}</span>
              </template>
              <img class="sbxs ml4" src="../../assets/img/ss-delete.png"  width="22" height="22">
            </a-tooltip>
          </a-popconfirm>
        </a-col>
        <a-table
          :rowSelection="{
            selectedRowKeys: subMapToRowKeys,
            onChange: onSubSelectMapto
          }"
          style="marginTop: 10px"
          :columns="SubmapTocolumns"
          :dataSource="SubmapTolist"
          size="small"
          :pagination="nopagination"
          :locale="tabelText"
          :loading="tableLoadingSub"
        >
          <template
            v-for="(item, index) in SubSlotsArray"
            :slot="item"
            slot-scope="text"
          >
            <span :key="index">
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span class="tableFontSize">{{ text }}</span>
                </template>
                <div class="tableFontSize">{{ text }}</div>
              </a-tooltip>
            </span>
          </template>
        </a-table>
        <a-pagination
          style="textAlign:right;margin:4px"
          size="small"
          :total="subPage.totalElements"
          :pageSize="subPage.TableSize"
          :showTotal="total => `Total ${subPage.totalElements} Records`"
          @change="subTablePageChange"
          showQuickJumper
        />
      </a-tab-pane>
    </a-tabs>

    <a-modal
      :title="$t('generic.Mapto')"
      v-model="subMapToVis"
      width="50%"
      :maskClosable="maskClosable"
      @cancel="subMapToVisCancel"
    >
      <template slot="footer">
        <a-button type="danger" @click="subMapToVisCancel">{{ $t('publicLang.Clear') }}</a-button>
        <a-button type="primary" @click="saveSub_MapTo">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="maptoSubForm">
        <a-row :span="7">
          <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
            <a-cascader
              allowClear
              :fieldNames="{
                label: 'moduleCode',
                value: 'key',
                children: 'children'
              }"
              :options="ModulesList"
              expandTrigger="hover"
              :placeholder="$t('publicLang.PleaseSelect')"
              v-model="modeluCodeMap"
            />
          </a-form-item>
        </a-row>
        <a-row :span="8">
          <a-form-item :label="$t('generic.MapToModule')" v-bind="formItemLayout">
            <a-cascader
              allowClear
              :fieldNames="{
                label: 'moduleCode',
                value: 'key',
                children: 'children'
              }"
              :options="ModulesListMapTo"
              expandTrigger="hover"
              :placeholder="$t('publicLang.PleaseSelect')"
              v-model="modeluCodeMapTo"
            />
          </a-form-item>
        </a-row>
        <a-row :span="8">
          <a-form-item :label="$t('generic.FieldMap')" v-bind="formItemLayout">
            <a-select
              allowClear
              :placeholder="$t('publicLang.PleaseSelect')"
              @dropdownVisibleChange="changeAjaxList"
              v-decorator="[
                'subMapUid',
                {
                  rules: [{ required: true, message: $t('publicLang.Required') }]
                }
              ]">
              <a-select-option
                v-for="(item, index) in FormFieldMapList"
                :key="index"
                :value="item.fieldMapUid">{{ item.mapName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-row>
      </a-form>
    </a-modal>

    <a-modal
      :title="$t('generic.Mapto')"
      v-model="visibleMapTo"
      width="70%"
      :maskClosable="maskClosable"
      @cancel="cancelMapTo"
    >
      <template slot="footer">
        <!--<a-button type="danger">重置</a-button>-->
        <a-button type="primary" @click="SaveMapTo">{{ $t('publicLang.Save') }}</a-button>
      </template>

      <a-form :form="maptoForm">
        <a-row>
          <a-col :span="8">
            <a-form-item v-bind="formItemLayout" :label="$t('generic.Type')">
              <a-select
                :placeholder="$t('publicLang.PleaseSelect')"
                v-model="mapToType"
                size="small"
                @change="maptoTypeChange"
              >
                <a-select-option value="DB">Field to Field</a-select-option>
                <a-select-option value="EXCEL">Excel Field</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!--Project-->
          <a-col :span="8">
            <a-form-item v-bind="formItemLayout" :label="$t('generic.Project')">
              <a-select
                :placeholder="$t('publicLang.PleaseSelect')"
                size="small"
                v-decorator="[
                  'projectCode',
                  {
                    initialValue: mapToEditData.projectCode,
                    rules: [{ required: false, message: $t('publicLang.Required') }]
                  }
                ]">
                <a-select-option
                  v-for="item in mapToProjectArr"
                  :value="item.key"
                  >{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!--Template Name-->
          <a-col :span="8">
            <a-form-item v-bind="formItemLayout" :label="$t('generic.TemplateName')">
              <a-input
                size="small"
                :placeholder="$t('generic.TemplateName')"
                v-decorator="[
                  'mapName',
                  {
                    initialValue: mapToEditData.mapName,
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              /> </a-form-item
          ></a-col>
          <!--Usage-->
          <a-col :span="8"
            ><a-form-item v-bind="formItemLayout" :label="$t('generic.Usage')">
              <a-select
                :placeholder="$t('publicLang.PleaseSelect')"
                size="small"
                v-decorator="[
                  'usage',
                  {
                    initialValue: mapToEditData.usage,
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              >
                <a-select-option value="NOR">Normal</a-select-option>
                <a-select-option value="SYS">System</a-select-option>
              </a-select>
            </a-form-item></a-col
          >
          <!--Source map-->
          <a-col :span="8">
            <a-form-item v-bind="formItemLayout" :label="$t('generic.Source')">
              <span v-if="mapToType == 'EXCEL'">{{ $t('generic.Excel') }}</span>
              <a-cascader
                v-else
                size="small"
                @change="getCasderSourceMap"
                allowClear
                :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                :options="ModulesList"
                expandTrigger="hover"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'fromModuleCode',
                  {
                    initialValue:
                      mapToEditData.parentFromModuleCode == undefined
                        ? []
                        : [
                            mapToEditData.parentFromModuleCode,
                            mapToEditData.fromModuleCode
                          ],
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"/></a-form-item>
              </a-col>
          <!--Target To-->
          <a-col :span="8">
            <a-form-item v-bind="formItemLayout" :label="$t('generic.TargetTo')">
              <a-cascader
                allowClear
                size="small"
                @change="getCasderTargetTo"
                :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                :options="ModulesListMapTo"
                expandTrigger="hover"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'toModuleCode',
                  {
                    initialValue:
                      mapToEditData.parentToModuleCode == undefined
                        ? []
                        : [
                            mapToEditData.parentToModuleCode,
                            mapToEditData.toModuleCode
                          ],
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              /></a-form-item
          ></a-col>
        </a-row>
        <a-row>
          <!--ExcelType-->
          <a-col :span="8" v-if="mapToType == 'EXCEL'"
            ><a-form-item v-bind="formItemLayout" :label="$t('generic.ExcelType')">
              <a-select
                placeholder="Please select ExcelType"
                size="small"
                v-decorator="[
                  'excelMode',
                  {
                    initialValue: mapToEditData.excelMode,
                    rules: [{ required: true, message: $t('publicLang.Required') }]
                  }
                ]"
              >
                <a-select-option value="MIX">Mixture</a-select-option>
                <a-select-option value="SINGLE">Single</a-select-option>
                <a-select-option value="DETAIL">Detail</a-select-option>
              </a-select>
            </a-form-item></a-col
          >
          <a-col :span="8" v-if="mapToType == 'EXCEL'">
            <a-form-item label="Excel Column" v-bind="formItemLayout">
              <a-row type="flex">
                <a-col :span="20">
                  <a-tooltip :trigger="['focus']" placement="topLeft">
                    <template slot="title">
                      <span v-if="ExcelColumnName.length > 0">{{ExcelColumnName}}</span>
                      <span v-else>{{ $t('generic.OnlyAllowLetter') }}</span>
                    </template>
                    <a-input
                      :placeholder="$t('publicLang.PleaseEnter')"
                      size="small"
                      v-model="ExcelColumnName"
                      @change="ExcelColumnChange"
                    />
                  </a-tooltip>
                </a-col>
                <a-col :span="2" style="margin-left: 2px;">
                  <a-button type="primary" size="small" @click="addExcelName"><span style="font-size: 12px">{{ $t('generic.Add') }}</span></a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>

          <a-col
            :span="8"
            v-if="mapToType == 'EXCEL' && partTabRowsArr.length == 1"
          >
            <a-form-item label="Export" v-bind="formItemLayout">
              <a-button type="primary" size="small" @click="ExportExcelChange">{{ $t('generic.Export') }}</a-button>
            </a-form-item>
          </a-col>
        </a-row>
        <hr  style="margin-bottom: 10px;"/>
        <a-row type="flex" justify="start">
          <a-row type="flex" align="middle" justify="start">
            <a-col style="text-align: right">
              <span style="font-size: 12px">{{ $t('generic.SourceMap') }}：</span>
            </a-col>
            <a-col>
              <a-transfer
                :dataSource="MapMockData"
                :targetKeys="sourceMapKeys"
                :render="item => item.title"
                @change="sourceMapChange"
                @selectChange="sourceMapSlectChange"
                :listStyle="{
                  width: '300px',
                  height: '300px'
                }"
              />
            </a-col>
            <a-col style="margin-left: 4px;">
              <a-row
                ><a-button
                  @click="sortTensfer('source', '1')"
                  type="primary"
                  shape="circle"
                  icon="double-right"
                  size="small"
                  style="transform: rotate(-90deg);margin-top: 10px;"
                ></a-button
              ></a-row>
              <a-row
                ><a-button
                  @click="sortTensfer('source', '2')"
                  type="primary"
                  shape="circle"
                  icon="up"
                  size="small"
                  style="margin-top: 10px;"
                ></a-button
              ></a-row>
              <a-row
                ><a-button
                  @click="sortTensfer('source', '3')"
                  type="primary"
                  shape="circle"
                  icon="down"
                  size="small"
                  style="margin-top: 10px;"
                ></a-button
              ></a-row>
              <a-row
                ><a-button
                  @click="sortTensfer('source', '4')"
                  type="primary"
                  shape="circle"
                  icon="double-right"
                  size="small"
                  style="transform: rotate(90deg);margin-top: 10px;"
                ></a-button
              ></a-row>
            </a-col>
          </a-row>
          <a-col>
            <a-button type="primary" @click="MaptoDuibi">{{ $t('generic.MapToView') }}</a-button>
          </a-col>
        </a-row>

        <a-row
          type="flex"
          align="middle"
          justify="start"
          style="margin-top: 4px;"
        >
          <a-row type="flex" align="middle" justify="start">
            <a-col style="text-align: right">
              <span style="font-size: 12px">{{ $t('generic.TargetMap') }}：</span>
            </a-col>
            <a-col>
              <a-transfer
                :dataSource="targetMapData"
                :targetKeys="targetMapKeys"
                @change="TargetMapChange"
                @selectChange="targetSelectChange"
                :render="item => item.title"
                :listStyle="{
                  width: '300px',
                  height: '300px'
                }"
              />
            </a-col>
            <a-col style="margin-left: 4px;">
              <a-row
                ><a-button
                  @click="sortTensfer('target', '1')"
                  type="primary"
                  shape="circle"
                  icon="double-right"
                  size="small"
                  style="transform: rotate(-90deg);margin-top: 10px;"
                ></a-button
              ></a-row>
              <a-row
                ><a-button
                  @click="sortTensfer('target', '2')"
                  type="primary"
                  shape="circle"
                  icon="up"
                  size="small"
                  style="margin-top: 10px;"
                ></a-button
              ></a-row>
              <a-row
                ><a-button
                  @click="sortTensfer('target', '3')"
                  type="primary"
                  shape="circle"
                  icon="down"
                  size="small"
                  style="margin-top: 10px;"
                ></a-button
              ></a-row>
              <a-row
                ><a-button
                  @click="sortTensfer('target', '4')"
                  type="primary"
                  shape="circle"
                  icon="double-right"
                  size="small"
                  style="transform: rotate(90deg);margin-top: 10px;"
                ></a-button
              ></a-row>
            </a-col>
          </a-row>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      :title="$t('generic.Mapto')"
      v-model="visibleMapToView"
      :maskClosable="maskClosable"
    >
      <div>
        <div v-for="item in querySourceTargetList">
          <span>{{ item.source }}</span> -----><span>{{ item.targetMap }}</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import ajax from "../../api/ajax";
import api from "../../api/url";
import { mapState } from "vuex";
import axios from "axios";
import cookie from "../../api/cookie";
export default {
  data () {
    return {
      visibleMapToView: false,
      parentRecord: "", // 父table uid
      tabelText: {
        emptyText: "No record found"
      }, // table
      maskClosable: false, // 取消遮罩
      maptoForm: this.$form.createForm(this), //  mapto 表单
      formItemLayout: {
        labelCol: {
          xs: { span: 8 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      }, // 表单样式
      //                表格数据
      nopagination: false, // 取消分页
      mapTocolumns: [
        {
          title: "Map Name",
          dataIndex: "mapName",
          scopedSlots: { customRender: "mapName" }
        },
        {
          title: "fromModuleCode",
          dataIndex: "fromModuleCode",
          scopedSlots: { customRender: "fromModuleCode" }
        },
        {
          title: "To Module Code",
          dataIndex: "toModuleCode",
          scopedSlots: { customRender: "toModuleCode" }
        },
        {
          title: "Status",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        },
        {
          title: "Remarks",
          dataIndex: "remarks",
          scopedSlots: { customRender: "remarks" }
        },
        {
          title: "Creator",
          dataIndex: "creator",
          scopedSlots: { customRender: "creator" }
        },
        {
          title: "Create Time",
          dataIndex: "createTime",
          scopedSlots: { customRender: "createTime" }
        },
        {
          title: "Modifier",
          dataIndex: "modifier",
          scopedSlots: { customRender: "modifier" }
        },
        {
          title: "Modify Time",
          dataIndex: "modifyTime",
          scopedSlots: { customRender: "modifyTime" }
        }
      ], // 父表头
      scopedSlotsArray: [
        "mapName",
        "fromModuleCode",
        "toModuleCode",
        "status",
        "remarks",
        "creator",
        "createTime",
        "modifier",
        "modifyTime"
      ],
      partTablist: [], // part data
      partselectedRowKeys: [],
      partTabRowsArr: [], // table check arr

      partTabPage: {
        totalElements: 0, // genericheader 总条数
        mapToPageCurrent: 1, // 默认当当前页面
        pageSize: 5, // 显示条数
        pageNum: 1 // 页数
      }, // 父table 分页
      parTableLoading: false, // part loading

      //                子表格
      SubmapTocolumns: [
        {
          title: "Map Name",
          dataIndex: "mapName",
          scopedSlots: { customRender: "mapName" }
        },
        {
          title: "fromModuleCode",
          dataIndex: "fromModuleCode",
          scopedSlots: { customRender: "fromModuleCode" }
        },
        {
          title: "To Module Code",
          dataIndex: "toModuleCode",
          scopedSlots: { customRender: "toModuleCode" }
        }
      ],
      SubSlotsArray: ["mapName", "fromModuleCode", "toModuleCode"],
      SubmapTolist: [],
      subMapToRowKeys: [],
      subMaptoRows: [],
      subPage: {
        totalElements: 0,
        TableSize: 5,
        pageNum: 1
      },
      tableLoadingSub: false,
      //                弹窗
      visibleMapTo: false,
      //                下面table弹窗
      subMapToVis: false,
      maptoSubForm: this.$form.createForm(this),
      modeluCodeMapTo: [], // sub moduleTo select arr
      modeluCodeMap: [], // sub module select arr
      FormFieldMapList: [], // FieldMapList data

      MapMockData: [], // 穿梭框sourceMapdata
      sourceMapKeys: [], // 穿梭框sourceMap已经选中
      mapToProjectArr: [], // project 下拉data
      ExcelColumnName: "", // 新增ExcelName
      ModulesList: [], // module 下拉data
      ModulesListMapTo: [], // ModulenMapTo 下拉data
      sourceMapSelectedKeys: [], // source map 右边选中 排序用

      targetMapData: [], // 穿梭框 targetMap data
      targetMapKeys: [], // 穿梭框targetMap已经选中
      targetToMapSelectedKeys: [], // target to 右边选中 排序用

      mapToEditData: {}, // mapto 编辑数据
      mapToType: "DB",
      editMaptoType: "",
      querySourceTargetList: [] // 展示选中的mapto 数据对应
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState(["userUid"]),
    ...mapState(["lang"])
  },
  watch: {
    mapToType(val) {
      if (val == "EXCEL") {
        this.excelMapDataFn();
      } else {
        this.MapMockData = [];
      }
    }
  },
  methods: {
    ExportExcelChange() {
      let tt = "/generic/module/export";
        let ajaxurl = ajax.ajaxUrl();
        let params = {
            mapUid: this.partTabRowsArr[0].fieldMapuid,
            language: this.lang
        }
        axios.get(ajaxurl + tt,  {
            params:params,
            headers: {
                Authorization: cookie.getBearerToken()
            },
            responseType: "blob" //二进制流
        }).then(data=>{
            if (!data) {
                return;
            }
            var blob = new Blob([data.data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
            });
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.href = url;
            aLink.setAttribute("download", "excel.xls");
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
        })
    },
    MaptoDuibi() {
      if (this.sourceMapKeys.length == this.targetMapKeys.length) {
        let tt = [];
        for (let ii in this.sourceMapKeys) {
          tt.push({
            source: this.sourceMapKeys[ii].split("---")[0],
            targetMap: this.targetMapKeys[ii].split("---")[0]
          });
        }
        this.querySourceTargetList = tt;
        this.visibleMapToView = true;
      } else {
        this.$customMessage.warning(this.$t('generic.SelectedMatched'));
      }
    },
    //      mapTo弹窗关闭清楚数据
    cancelMapTo() {
      this.visibleMapTo = false;
      this.maptoForm.resetFields();
      this.mapToEditData = {};
      this.MapMockData = [];
      this.targetMapData = [];
    },
    //            添加编辑
    addMapTo(type) {
      ajax.get(api.MAPPROJECT).then(res => {
        this.mapToProjectArr = res.data;
      });
      //        两个联动Module下拉
      ajax.get(api.GETMODULEDROPDATA).then(res => {
        this.ModulesList = res.data;
        this.ModulesListMapTo = res.data;
      });
      if (type == "add") {
        this.visibleMapTo = true;
      } else if (type == "edit") {
        if (this.partTabRowsArr.length != 1) {
          this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
          return;
        } else {
          this.visibleMapTo = true;
          let params = {
            fieldMapUid: this.partTabRowsArr[0].fieldMapuid
          };
          ajax.get(api.FIELMAPDETAIL, params).then(res => {
            this.mapToEditData = res.data;
            if (this.mapToEditData.fromModuleCode == "EXCEL") {
              this.mapToType = "EXCEL";
              this.excelMapDataFn();
              this.getCasderTargetTo(
                ["", this.mapToEditData.toModuleCode],
                "ev"
              );
            } else {
              this.mapToType = "DB";
              this.getCasderTargetTo(
                ["", this.mapToEditData.toModuleCode],
                "ev"
              );
              this.getCasderSourceMap(
                ["", this.mapToEditData.fromModuleCode],
                "ev"
              );
            }
          });
        }
      }
    },
    //      添加Excel
    addExcelName() {
      let excelText = this.ExcelColumnName.toUpperCase();
      if (excelText != "") {
        let result = this.MapMockData.some(item => {
          if (item.title == excelText) {
            return true;
          }
        });
        if (result) {
          // 如果存在
          this.$customMessage.warning(this.$t('generic.DataDuplication'));
          return false;
        } else {
          this.ExcelColumnName = excelText;
          this.MapMockData.push({
            key: excelText,
            title: excelText,
            chosen: true
          });
        }
      }
    },
    //      只能添加字母
    ExcelColumnChange(val) {
      let reg = /^[a-zA-Z]+$/;
      if (!reg.test(this.ExcelColumnName)) {
        this.ExcelColumnName = "";
      }
    },
    //      mapto 提交
    SaveMapTo() {
      this.maptoForm.validateFields((err, val) => {
        if (!err) {
          let fromFields = [];
          let toFields = [];

          this.sourceMapKeys.forEach((v, i) => {
            let tt = v.split("---");
            fromFields.push({
              fieldMapDetailUid: tt[1] == "undefined" ? "" : tt[1],
              fromFieldName: tt[0]
            });
          });
          this.targetMapKeys.forEach((v, i) => {
            let tt = v.split("---");
            toFields.push({
              fieldMapDetailUid: tt[1] == "undefined" ? "" : tt[1],
              toFieldName: tt[0]
            });
          });
          if (fromFields.length != toFields.length) {
            this.$customMessage.warning(this.$t('generic.SelectedMatched'));
            return;
          }
          let params = {
            fromFields: fromFields,
            fromModuleCode:
              this.mapToType == "EXCEL" ? "EXCEL" : val.fromModuleCode[1],
            mapName: val.mapName,
            mapType: this.mapToType,
            projectCode: val.projectCode,
            toFields: toFields,
            toModuleCode: val.toModuleCode[1],
            usage: val.usage,
            excelMode: val.excelMode,
            fieldMapUid:
              this.mapToEditData.fieldMapUid == undefined
                ? null
                : this.mapToEditData.fieldMapUid
          };
          ajax.post(api.FIELMAP, params).then(res => {
            if (res.code == 200) {
              this.visibleMapTo = false;
              this.partselectedRowKeys = [];
              this.cancelMapTo();
              this.init();
            }
          });
        }
      });
    },
    //      26字母excel 穿梭框
    excelMapDataFn() {
      this.sourceMapKeys = [];
      this.MapMockData = [];
      let codeArr = this.generateBig_1();
      let pushArr = [];

      let editArr = [];
      if (this.mapToEditData.fromFields != undefined) {
        this.mapToEditData.fromFields.forEach((v, i) => {
          editArr.push({
            FieldName: v.fromFieldName,
            fieldMapDetailUid: v.fieldMapDetailUid
          });
        });
        codeArr = this.filterMapArr(codeArr.concat(editArr));
      }
      let editCheck = [];
      codeArr.forEach((v, i) => {
        const data = {
          key: v.FieldName + "---" + v.fieldMapDetailUid,
          title: v.FieldName,
          chosen: v.fieldMapDetailUid != undefined ? true : false
        };
        if (data.chosen) {
          editCheck.push(data.key);
        }
        pushArr.push(data);
      });
      this.sourceMapKeys = editCheck;
      this.MapMockData = pushArr;
    },
    //    排序 start
    sortTensfer(type, val) {
      if (type == "target") {
        if (this.targetToMapSelectedKeys.length == 1) {
          if (val == "1") {
            //                    置顶
            this.targetMapKeys.forEach((v, i) => {
              if (v == this.targetToMapSelectedKeys[0]) {
                this.targetMapKeys.splice(i, 1);
                this.targetMapKeys.unshift(this.targetToMapSelectedKeys[0]);
              }
            });
          } else if (val == "2") {
            //                    网上排序
            let index = "";
            this.targetMapKeys.forEach((v, i) => {
              if (v == this.targetToMapSelectedKeys[0]) {
                index = i;
              }
            });
            if (index == 0) {
              return false;
            }
            let temp = this.targetMapKeys[index - 1];
            this.targetMapKeys[index - 1] = this.targetMapKeys[index];
            this.targetMapKeys[index] = temp;
            //                    触发data改变
            this.targetMapKeys.push("");
            this.targetMapKeys.pop();
          } else if (val == "3") {
            //                    网下排序
            let index = "";
            this.targetMapKeys.forEach((v, i) => {
              if (v == this.targetToMapSelectedKeys[0]) {
                index = i;
              }
            });
            if (index + 1 == this.targetMapKeys.length) {
              return;
            }
            let temp = this.targetMapKeys[index + 1];
            let temp1 = this.targetMapKeys[index];
            this.targetMapKeys[index + 1] = temp1;
            this.targetMapKeys[index] = temp;
            //                    触发data改变
            this.targetMapKeys.push("");
            this.targetMapKeys.pop();
          } else if (val == "4") {
            //                    置低
            this.targetMapKeys.forEach((v, i) => {
              if (v == this.targetToMapSelectedKeys[0]) {
                this.targetMapKeys.splice(i, 1);
                this.targetMapKeys.push(this.targetToMapSelectedKeys[0]);
              }
            });
          }
        } else {
          this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
        }
      } else {
        if (this.sourceMapSelectedKeys.length == 1) {
          if (val == "1") {
            //                    置顶
            this.sourceMapKeys.forEach((v, i) => {
              if (v == this.sourceMapSelectedKeys[0]) {
                this.sourceMapKeys.splice(i, 1);
                this.sourceMapKeys.unshift(this.sourceMapSelectedKeys[0]);
              }
            });
          } else if (val == "2") {
            //                    网上排序
            let index = "";
            this.sourceMapKeys.forEach((v, i) => {
              if (v == this.sourceMapSelectedKeys[0]) {
                index = i;
              }
            });
            if (index == 0) {
              return false;
            }
            let temp = this.sourceMapKeys[index - 1];
            this.sourceMapKeys[index - 1] = this.sourceMapKeys[index];
            this.sourceMapKeys[index] = temp;
            //                    触发data改变
            this.sourceMapKeys.push("");
            this.sourceMapKeys.pop();
          } else if (val == "3") {
            //                    网下排序
            let index = "";
            this.sourceMapKeys.forEach((v, i) => {
              if (v == this.sourceMapSelectedKeys[0]) {
                index = i;
              }
            });
            if (index + 1 == this.targetMapKeys.length) {
              return;
            }
            let temp = this.sourceMapKeys[index + 1];
            let temp1 = this.sourceMapKeys[index];
            this.sourceMapKeys[index + 1] = temp1;
            this.sourceMapKeys[index] = temp;
            //                    触发data改变
            this.sourceMapKeys.push("");
            this.sourceMapKeys.pop();
          } else if (val == "4") {
            //                    置低
            this.sourceMapKeys.forEach((v, i) => {
              if (v == this.sourceMapSelectedKeys[0]) {
                this.sourceMapKeys.splice(i, 1);
                this.sourceMapKeys.push(this.sourceMapSelectedKeys[0]);
              }
            });
          }
        } else {
          this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
        }
      }
    },
    targetSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.targetToMapSelectedKeys = targetSelectedKeys;
    },
    //      sourceMap穿梭框 start
    sourceMapSlectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.sourceMapSelectedKeys = targetSelectedKeys;
    },
    //     生成26大写字母
    generateBig_1() {
      let str = [];
      for (let i = 65; i < 91; i++) {
        const obj = {
          FieldName: String.fromCharCode(i)
        };
        str.push(obj);
      }
      return str;
    },
    //      获取data
    getCasderSourceMap(val, ev) {
      if (val.length < 1) {
        this.MapMockData = [];
        return false;
      }
      this.MapMockData = [];
      this.sourceMapKeys = [];
      ajax.get(api.GETSCHEMADETAIL, { subModuleCode: val[1] }).then(res => {
        let SourceMapArr = res.data;
        let pushArr = [];

        let editArr = [];
        if (this.mapToEditData.fromFields != undefined) {
          this.mapToEditData.fromFields.forEach((v, i) => {
            editArr.push({
              FieldName: v.fromFieldName,
              fieldMapDetailUid: v.fieldMapDetailUid
            });
          });
          SourceMapArr = this.filterMapArr(SourceMapArr.concat(editArr));
        }
        let editCheck = [];
        SourceMapArr.forEach((v, i) => {
          const data = {
            key: v.FieldName + "---" + v.fieldMapDetailUid,
            title: v.FieldName,
            chosen: v.fieldMapDetailUid != undefined ? true : false
          };
          if (data.chosen) {
            editCheck.push(data.key);
          }
          pushArr.push(data);
        });
        if (ev == "ev") {
          this.sourceMapKeys = editCheck;
        } else {
          this.sourceMapKeys = [];
        }
        this.MapMockData = pushArr;
      });
    },
    //      获取选中
    sourceMapChange(targetKeys) {
      this.sourceMapKeys = targetKeys;
    },
    //      sourceMap穿梭框 end
    //      TargetMap穿梭框start
    TargetMapChange(targetKeys) {
      this.targetMapKeys = targetKeys;
    },
    //      下拉获取数据请求TargetTo 穿梭数据
    getCasderTargetTo(val, ev) {
      this.targetMapData = [];
      this.targetMapKeys = [];
      if (val.length < 1) {
        return false;
      }
      ajax.get(api.GETSCHEMADETAIL, { subModuleCode: val[1] }).then(res => {
        let targetMapArr = res.data; // 总数据
        let editArr = []; // 编辑选中的arr
        let editCheck = []; // 选中的arr

        if (this.mapToEditData.toFields != undefined) {
          this.mapToEditData.toFields.forEach((v, i) => {
            editArr.push({
              FieldName: v.toFieldName,
              fieldMapDetailUid: v.fieldMapDetailUid
            });
          });
          // 坑比后台需要数据格式这样，慢慢看就不注释
          targetMapArr = this.filterMapArr(targetMapArr.concat(editArr));
        }
        let pushArr = [];
        targetMapArr.forEach((v, i) => {
          const data = {
            key: v.FieldName + "---" + v.fieldMapDetailUid,
            title: v.FieldName,
            chosen: v.fieldMapDetailUid != undefined ? true : false
          };
          if (data.chosen) {
            editCheck.push(data.key);
          }
          pushArr.push(data);
        });
        if (ev == "ev") {
          this.targetMapKeys = editCheck;
        } else {
          this.targetMapKeys = [];
        }
        this.targetMapData = pushArr;
      });
    },
    maptoTypeChange() {
      this.editMaptoType = 1;
    },
    filterMapArr(arr) {
      let targetMapArr = arr;
      let temptab = [];
      for (let ii in targetMapArr) {
        let flag = 0;
        let firstpsoro;
        for (let jj in temptab) {
          if (temptab[jj].FieldName == targetMapArr[ii].FieldName) {
            flag++;
            firstpsoro = jj;
            break;
          }
        }
        if (flag == 0) {
          temptab.push(targetMapArr[ii]);
        } else {
          if (targetMapArr[ii].fieldMapDetailUid) {
            temptab.splice(firstpsoro, 1);
            temptab.push(targetMapArr[ii]);
          } else {
            temptab.push(targetMapArr[ii]);
          }
        }
      }
      return temptab;
    },
    //      TargetMap穿梭框end
    //  初始化数据
    init() {
      ajax.get(api.GETMODULEDROPDATA).then(res => {
        this.ModulesList = res.data;
        this.ModulesListMapTo = res.data;
      });
      this.parTableLoading = true;
      let params = {
        pageNum: this.partTabPage.pageNum,
        pageSize: this.partTabPage.pageSize
      };
      ajax.get(api.FIELMAP, params).then(res => {
        this.parTableLoading = false;
        this.partTablist = res.data.content;
        this.partTabPage.totalElements = res.data.totalElements;
      });
    },
    //  父table 删除
    deleteMaptoPar() {
      if (this.partTabRowsArr.length < 1) {
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
        return;
      }
      let uids = [];
      this.partTabRowsArr.forEach(v => {
        uids.push(v.fieldMapuid);
      });
      let params = {
        uids: uids
      };
      ajax.post(api.DELETIONFIELMAP, params).then(res => {
        if (res.code == 200) {
          this.init();
        }
      });
    },
    //    父table 分页
    partTabChange(page) {
      this.partTabPage.pageNum = page;
      this.init();
    },
    // sub table cancel data重置
    subMapToVisCancel() {
      this.maptoSubForm.resetFields();
      this.modeluCodeMapTo = [];
      this.modeluCodeMap = [];
      this.subMapToVis = false;
    },
    //  sub delete
    deleteMaptoSub() {
      if (this.subMaptoRows.length < 1) {
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
        return;
      }
      let uids = [];
      this.subMaptoRows.forEach(v => {
        uids.push(v.subUid);
      });
      let params = {
        uids: uids
      };
      ajax.post(api.DELETESUBFIELMAP, params).then(res => {
        if (res.code == 200) {
          this.parrecordIdApiList();
        }
      });
    },
    // sub add edit submit
    saveSub_MapTo() {
      this.maptoSubForm.validateFields((err, val) => {
        if (!err) {
          let params = {
            headerMapUid: this.parentRecord,
            subMapUid: val.subMapUid
          };
          ajax.post(api.SUBFIELMAP, params).then(res => {
            if (res.code == 200) {
              this.subMapToVis = false;
              this.parrecordIdApiList();
              this.maptoSubForm.resetFields();
              this.modeluCodeMapTo = [];
              this.modeluCodeMap = [];
            }
          });
        }
      });
    },
    //      sub add
    addSubMapTo() {
      if (this.parentRecord == "") {
        this.$customMessage.warning(this.$t('publicLang.PleaseFirst'));
        return;
      }
      this.subMapToVis = true;
    },
    //    sub 选择module module to 选择FormField
    changeAjaxList() {
      let params = {
        fromModuleCode:
          this.modeluCodeMap[1] == undefined ? "" : this.modeluCodeMap[1],
        toModuleCode:
          this.modeluCodeMapTo[1] == undefined ? "" : this.modeluCodeMapTo[1]
      };
      ajax.get(api.DROPFIELMAP, params).then(res => {
        this.FormFieldMapList = res.data;
      });
    },

    //  附表个点击事件
    customRowEvent(record, index) {
      return {
        on: {
          click: () => {
            this.parentRecord = record.fieldMapuid;
            this.parrecordIdApiList();
          },
          dblclick: () => {
            this.partselectedRowKeys = [];
            this.partTabRowsArr = [];

            this.partselectedRowKeys.push(index);
            this.partTabRowsArr.push(record);
            this.addMapTo("edit");
          }
        }
      };
    },
    // 点击父表格请求sub table
    parrecordIdApiList() {
      this.tableLoadingSub = true;
      let params = {
        pageNum: this.subPage.pageNum,
        pageSize: this.subPage.TableSize,
        parentUid: this.parentRecord
      };
      ajax.get(api.FIELMAP, params).then(res => {
        this.tableLoadingSub = false;
        this.subPage.totalElements = res.data.totalElements;
        this.SubmapTolist = res.data.content;
      });
    },
    // sub table 分页
    subTablePageChange(page) {
      this.subPage.pageNum = page;
      this.parrecordIdApiList();
    },
    // 表格颜色class
    rowClassName(record) {
      return record.fieldMapuid == this.parentRecord ? "bg" : "";
    },
    //            表格事件
    onSelectChange(selectedRowKeys, selectedRows) {
      this.partselectedRowKeys = selectedRowKeys;
      this.partTabRowsArr = selectedRows;
    },
    onSubSelectMapto(selectedRowKeys, selectedRows) {
      this.subMapToRowKeys = selectedRowKeys;
      this.subMaptoRows = selectedRows;
    }
  }
};
</script>
<style lang="less">
#mapTo {
  .tt {
  }
  .bg {
    background: darkseagreen !important;
  }
  .cc {
    background: #fff;
  }
  .hh {
    background: #e7eef8;
  }
  background: #fff;
  height: 85vh;
}
</style>
